import { ImageWithAltType } from '../types';
import cn from '../utils/cn';
import { Image } from './Image';

interface HeroProps {
  overline?: string;
  title: string;
  image?: ImageWithAltType;
  description?: string;
  background?: 'primary' | 'background';
}

function Hero({ overline, title, image, description, background = 'background' }: HeroProps) {
  if (!title) return null;

  return (
    <section
      className={cn(
        background === 'primary'
          ? 'bg-primary text-background'
          : 'bg-background text-on-background',
      )}
    >
      <div className="max-w-8xl mx-auto">
        <div className="grid items-center sm:grid-cols-2">
          {/* TEXT */}
          <div className="px-6 py-10 sm:px-10 sm:py-20 md:max-w-3xl lg:px-20 lg:py-28">
            {overline && (
              <span
                className={`${background === 'primary' ? 'text-tertiary' : 'text-tertiary-variant'} mb-2 inline-block text-xl font-semibold lg:text-3xl`}
              >
                {overline}
              </span>
            )}

            <h1
              className="mb-5 text-[30px] font-semibold leading-none lg:mt-2 lg:text-5xl"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              style={{ textWrap: 'balance' }}
            >
              {title}
            </h1>
            {description && <p className="text-xl sm:text-2xl">{description}</p>}
          </div>
          {image?.asset && (
            <Image
              src={image}
              className="w-full h-full object-cover"
              width={1600}
              height={900}
              priority
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default Hero;
